import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-w-twoone-twotwo',
  templateUrl: './w-twoone-twotwo.component.html',
  styleUrls: ['./w-twoone-twotwo.component.scss']
})
export class WTwooneTwotwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
